export default __webpack_public_path__ + "static/media/img-0185-ireland-full-face.16bb9e83.png";